import { render, staticRenderFns } from "./OpensInNewTabIcon.vue?vue&type=template&id=f09cf88e&scoped=true"
import script from "./OpensInNewTabIcon.vue?vue&type=script&lang=js"
export * from "./OpensInNewTabIcon.vue?vue&type=script&lang=js"
import style0 from "./OpensInNewTabIcon.vue?vue&type=style&index=0&id=f09cf88e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f09cf88e",
  null
  
)

export default component.exports